<div class="text-center">
    <div class="spinner-border" [ngClass]="classes" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
